const isFriendUrl = process.env.REACT_APP_IS_FRIEND_URL === "true";
const localUrl = isFriendUrl ? process.env.REACT_APP_LOCAL_URL : "localhost";

const localURL = `http://${localUrl}:${process.env.REACT_APP_LOCAL_PORT}`;
const mavenProfServURL = process.env.REACT_APP_MAVEN_PROF_SERV_URL;
const mavenRegTechURL = process.env.REACT_APP_MAVEN_REG_TECH_URL;

const createURLs = (baseURL, proxyURL) => ({
  API_URL: `${baseURL}/api`,
  IMG_URL: `${baseURL}/`,
  PROXY_URL: proxyURL,
});

const localURLs = createURLs(localURL, `http://${localUrl}:${process.env.REACT_APP_PROXY_PORT}/`);
const mavenProfServURLs = createURLs(mavenProfServURL, process.env.REACT_APP_MAVEN_PROF_SERV_PROXY);
const mavenRegTechURLs = createURLs(mavenRegTechURL, process.env.REACT_APP_MAVEN_REG_TECH_PROXY);

const service =
  window.location.hostname.includes("localhost") ||
    window.location.hostname.endsWith(".me.mavenregulatory.com")
    ? localURLs
    : window.location.hostname.endsWith(".mavenprofserv.us")
      ? mavenProfServURLs
      : mavenRegTechURLs;

export default service;